import moment from "moment";

export default class CaseInformation {
  constructor(caseProgressItem) {
    this.data = caseProgressItem;
  }
  getPercentage() {
    if (!this.data?.template?.case_update_items) {
      this.percentage = 0;
      return this.percentage;
    }
    if (!this.data?.finished_steps) {
      this.percentage = 0;
      return this.percentage;
    }
    const {
      template: { case_update_items }
    } = this.data;
    const { finished_steps } = this.data;
    // let totalWeight = 0, currentWeight = 0

    const totalWeight = case_update_items.reduce((prev, current) => {
      const bottomFlag = current?.flag?.bottomflag;
      if (bottomFlag == "active") {
        return prev + current.workload;
      } else return prev;
    }, 0);
    const currentWeight = finished_steps.reduce((prev, current) => {
      const bottomFlag = current?.detail?.flag?.bottomflag;

      if (bottomFlag == "active" && current?.case_common_status != "REJECTED") {
        return prev + current?.workload;
      } else return prev;
    }, 0);
    const ret = (currentWeight / totalWeight) * 100;
    this.percentage = isNaN(ret) ? 0 : ret;
    return this.percentage;
  }
  getCurrentStep() {
    if (!this.currentStep) this.getCaseBottomFlag();
    return this.currentStep;
  }
  getCurrentStepLabel() {
    if (this.data.status_common == "PROSPECT") return "Prospect";
    if (this.data.status_common == "OFFERING") return "Proposal/Offering";
    if (this.data.status_common == "CANCELLED") return "Cancelled";
    // console.log(this.getCurrentStep());
    return this.getCurrentStep()?.case_step_label ?? null;
  }
  getCaseBottomFlag() {
    if (!this.data) return null;
    // if (this.currentFlag) return this.currentFlag;

    const { finished_steps } = this.data;
    const flags = finished_steps.map(x => {
      return x?.detail?.flag?.bottomflag;
    });
    let flag = null;
    this.currentFlag = "active";
    flag = "active";
    if (this.data.status_common == "PROSPECT") {
      this.currentStep = null;
      this.currentFlag = "prospect";
      flag = "prospect";

      // return this.currentFlag;
    }
    if (this.data.status_common == "OFFERING") {
      this.currentStep = null;
      this.currentFlag = "offering";
      flag = "offering";

      // return this.currentFlag;
    }
    if (this.data.status_common == "CANCELLED") {
      this.currentStep = null;
      this.currentFlag = "cancelled";
      flag = "cancelled";

      // return this.currentFlag;
    }
    if (this.data.status_common == "FINISHED") {
      this.currentStep = null;
      this.currentFlag = "finished";
      flag = "finished";

      // return this.currentFlag;
    }

    // console.log(flags);

    // console.log(flags);
    try {
      this.currentStep = finished_steps
        .filter(x => x.update_bottomflag == flag)
        .sort((a, b) =>
          moment(b.updated_at) > moment(a.updated_at) ? 1 : -1
        )[0];
    } catch (e) {
      // console.log(e);
      this.currentStep = null;
    }

    return this.currentFlag;
  }

  isApprovalRequired() {
    const currentStep = this.getCurrentStep();
    if (!currentStep) return false;
    return currentStep.approved == 0;
  }

  allowApproval(user_code) {
    if (this.data.contract.responsible_user == user_code) return true;
    if (this.data.contract.originating_user == user_code) return true;

    let allowApprove = false;
    (this.data.partner_worksplit ?? []).forEach(x => {
      if (x.user_code == user_code) allowApprove = true;
    });

    return allowApprove;
  }
}
